import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import _ from 'lodash';
import { Button, Modal, Form, Col, Alert } from 'react-bootstrap';
import FormControls, { ConditionalRender } from '../formControls';

const customerInitValues = {
    name: '',
    customerNumber: null,
    isParentAccount: false,
    emrVendorId: 0,
}

const customerValidation = Yup.object().shape({
    name: Yup.string().required('Account name is required.')
        .min(5, 'Account name must contain more than five characters.')
        .max(300, 'Account name must have less than 300 characters.'),
    customerNumber: Yup.number().nullable().required('Customer number is required.')
        .min(1, 'Customer number is required.'),
    emrVendorId: Yup
        .number()
        .when("isParentAccount", {
            is: false,
            then: Yup.number().nullable().min(1, 'EMR Vendor is required.')
        })
});

const CreateCustomerModal = (props) => {
    const [vendors, setVendors] = useImmer([]);
    const [customer, setCustomer] = useImmer(customerInitValues);
    const [saveError, setSaveError] = useImmer(null);

    useEffect(() => {
        setVendors(props.model);
    }, [])

    const formik = useFormik({
        initialValues: customer,
        validationSchema: customerValidation,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            var result = await props.saveModel(values)
            if (!result.result) {
                setSaveError(result.message);
            }
            setSubmitting(false);
        }
    });

    useEffect(() => {
        let vendorId = 0;
        if (formik.values.isParentAccount) {
            vendorId = 11; // need to change this later to default to -1 or make required field nullable.
        }
        formik.setFieldValue("emrVendorId", vendorId, false);
    }, [formik.values.isParentAccount])



    return (
        <>
            <Modal.Header>Create new customer</Modal.Header>
            <Modal.Body>
                <Form.Row>
                    <Alert variant='danger' show={saveError}>{saveError}</Alert>
                    <Form.Group as={Col} lg="12" md="12" controlId="name">
                        <FormControls.Textbox
                            name="name"
                            label="Customer Name"
                            formHandler={formik} />
                    </Form.Group>
                    <Form.Group as={Col} lg="12" md="12" controlId="name">
                        <FormControls.Checkbox
                            label="Is a Parent Account?"
                            name="isParentAccount"
                            formHandler={formik} />
                    </Form.Group>
                    <Form.Group as={Col} lg="12" md="12" controlId="name">
                        <FormControls.Numberbox
                            label="Customer Number"
                            name="customerNumber"
                            formHandler={formik} />
                    </Form.Group>
                    <ConditionalRender visible={!formik.values.isParentAccount}>
                        <Form.Group as={Col} lg="12" md="12" controlId="emrVendorId">
                            <FormControls.SelectBox
                                label="Vendor"
                                name="emrVendorId"
                                numeric
                                formHandler={formik}
                                defaultValue={0}
                                showDefault
                                defaultLabel="Select Vendor ..."
                                onChange={(e) => {
                                    const val = parseInt(e.target.value);
                                    formik.setFieldValue("emrVendorId", val, true)
                                }}
                                options={vendors}
                            />
                        </Form.Group>
                    </ConditionalRender>
                </Form.Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={props.hideModal}>Cancel</Button>
                <Button variant="primary" onClick={() => formik.submitForm()}>Save</Button>
            </Modal.Footer>
        </>
    );
}

export default CreateCustomerModal;

//class CreateCustomerModal extends Component {
//    constructor(props, context) {
//        super(props, context);
//        this.state = {
//            customer: { name: '', emrVendorId: null, customerNumber: '' },
//            errors: { name: '', emrVendorId: '', customerNumber: '', general: ''},
//            vendors: []
//        };

//        this.handleUserInput = this.handleUserInput.bind(this);
//        this.handleUserIntInput = this.handleUserIntInput.bind(this);
//    }

//    componentDidMount() {
//        this.setState({ vendors: this.props.model });
//    }

//    //saveModel() {
//    //    var customer = this.state.customer;

//    //    if (!(customer.name.length < 1
//    //        && customer.customerNumber.length < 1
//    //        && customer.emrVendorId !== null
//    //        && customer.emrVendorId != 0)) {

//    //        var result = this.props.saveModel(this.state.customer);
//    //        if (!result.result) {
//    //            var partialState = this.state.errors;
//    //            partialState.general = result.message;
//    //            this.setState({ errors: partialState });
//    //        }
//    //    }
//    //}

//    validateField(event) {
//        const { name } = event.target;
//        let errors = this.state.errors;

//        switch (name) {
//            case 'name':
//                errors.name =
//                    this.state.customer.name.length < 1
//                        ? 'Name is not valid!'
//                        : '';
//                break;
//            case 'customerNumber':
//                errors.customerNumber =
//                    this.state.customer.customerNumber.length < 1
//                        ? 'Customer Number is not valid!'
//                        : '';
//                break;

//            case 'emrVendorId':
//                errors.phoneType =
//                    this.state.customer.emrVendorId !== null && this.state.customer.emrVendorId != 0
//                        ? '' : 'Invalid emrVendorId';
//                break;
//            default:
//                break;
//        }

//        this.setState({ errors })
//    }

//    handleUserInput(event) {
//        // taken straight from the React Docs
//        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
//        const target = event.target;
//        const value = target.type === 'checkbox' ? target.checked : target.value;
//        const name = target.name;
//        var partialState = this.state.customer;
//        partialState[name] = value;
//        this.setState({ customer: partialState });
//    }

//    handleUserIntInput(event) {
//        // taken straight from the React Docs
//        // https://reactjs.org/docs/forms.html#handling-multiple-inputs
//        const target = event.target;
//        const value = parseInt(target.value);
//        const name = target.name;
//        var partialState = this.state.customer;
//        partialState[name] = value;
//        this.setState({ customer: partialState });
//    }

//    render() {
//        return (
//            <>
//                <Modal.Header>Create new customer</Modal.Header>
//                <Modal.Body>
//                    <Form.Row>
//                        <Form.Group as={Col} lg="12" md="12" controlId="name">
//                            <Form.Label>Name</Form.Label>
//                            <Form.Control placeholder="" name="name" id="name" value={this.state.customer.name} onChange={this.handleUserInput} />
//                        </Form.Group>
//                        <Form.Group as={Col} lg="12" md="12" controlId="name">
//                            <Form.Label>Customer Number</Form.Label>
//                            <Form.Control placeholder="" name="customerNumber" id="customerNumber" value={this.state.customer.customerNumber} onChange={this.handleUserIntInput} />
//                        </Form.Group>
//                        <Form.Group as={Col} lg="12" md="12" controlId="emrVendorId">
//                            <Form.Label>Vendor</Form.Label>
//                            <Form.Control as="select" value={this.state.customer.emrVendorId} name="emrVendorId" id="emrVendorId" onChange={this.handleUserIntInput} >
//                                <option key="0" value="0">Select Vendor...</option>
//                                {
//                                    this.state.vendors.map((vendor) => {
//                                        return <option key={vendor.id} value={vendor.id}>{vendor.name}</option>
//                                    })
//                                }
//                            </Form.Control>
//                        </Form.Group>
//                    </Form.Row>
//                    <Alert variant="danger" style={this.state.errors.general != '' ? null : { "display": "none" }}>
//                        {this.state.errors.general}
//                    </Alert>
//                </Modal.Body>
//                <Modal.Footer>
//                    <Button bsStyle="default" onClick={this.props.hideModal}>Cancel</Button>
//                    <Button bsStyle="primary" onClick={() => this.props.saveModel(this.state.customer)}>Save</Button>
//                </Modal.Footer>
//            </>
//        );
//    }
//}

//export default CreateCustomerModal